module.exports = __webpack_public_path__ + "img/20190727140903382.f12b872c.png";